import { debounce } from "lodash";
import sizesConfig from "../../config/sizes-config.json";
import sizesConversionConfig from "../../config/sizes-conversion-config.json";

window.dAgency.initializeSelectRemoveAll = (rootElement) => {
  rootElement.querySelectorAll('.facets-bulk-actions__select-all').forEach(selectAll => {
    selectAll.addEventListener('click', () => {
      selectAll.closest('.js-filter').querySelectorAll('.facets__element:not(.hidden) input:not(:checked) + label').forEach(label => {
        label.click();
      });
    });
  });

  rootElement.querySelectorAll('.facets-bulk-actions__remove-all').forEach(removeAll => {
    removeAll.addEventListener('click', () => {
      removeAll.closest('.js-filter').querySelectorAll('.facets__element:not(.hidden) input:checked + label').forEach(label => {
        label.click();
      });
    });
  });
};

window.dAgency.searchFilter = (value, wrapper) => {
  wrapper.querySelectorAll('.facets__element').forEach(element => {
    const labelValue = element.querySelector('label').innerText.toLowerCase();
    if (value.toLowerCase()) {
      if (labelValue.indexOf(value.toLowerCase()) < 0) {
        element.classList.add('hidden');
      } else {
        element.classList.remove('hidden');
      }
    } else {
      element.classList.remove('hidden');
    }
  });

  const hiddenFields = wrapper.querySelectorAll('.facets__element:not(.hidden)').length;
  const noResultsLabel = wrapper.querySelector('.facets__no-results');
  if (hiddenFields == 0) {
    noResultsLabel.classList.remove('hidden');
  } else {
    noResultsLabel.classList.add('hidden');
  }
};

window.dAgency.addSearchEvents = (wrapper) => {
  const input = wrapper.querySelector('input[type="text"]');
  const searchIcon = wrapper.querySelector('.facets-search__btn--search');
  const closeIcon = wrapper.querySelector('.facets-search__btn--close');
  if (input && searchIcon && closeIcon) {
    searchIcon.addEventListener('click', () => { input.focus(); });
    closeIcon.addEventListener('click', () => {
      input.value = '';
      window.dAgency.searchFilter(input.value, wrapper.closest('.js-filter'));
    });
  }
};

window.dAgency.sizeSelectChange = (value, wrapper) => {
  if (value === 'other') {
    wrapper.querySelectorAll('label:not([data-category])').forEach(label => {
      label.closest('.facets__element').classList.remove('hidden');
    });

    wrapper.querySelectorAll('label[data-category]').forEach(label => {
      label.closest('.facets__element').classList.add('hidden');
    });
  } else {
    wrapper.querySelectorAll(`label[data-category="${value}"]`).forEach(label => {
      label.closest('.facets__element').classList.remove('hidden');
    });

    wrapper.querySelectorAll(`label:not([data-category="${value}"])`).forEach(label => {
      label.closest('.facets__element').classList.add('hidden');
    });
  }
};

window.dAgency.updateSizesFilter = wrapper => {
  var categories = null;
  if (wrapper?.dataset?.sizeCategory === 'shoe') {
    categories = sizesConfig.shoe_sizes;
  } else if (wrapper?.dataset?.sizeCategory === 'clothing') {
    categories = sizesConfig.clothing_sizes;
  }
  const categoryInput = wrapper.querySelector('input[data-selected-category]');
  const categoriesSelect = wrapper.querySelector('.facets__size-select');
  if (!categories || !categoriesSelect || !categoryInput) return;

  categories.forEach(category => {
    category.values.forEach(value => {
      const label = wrapper.querySelector(`label[data-filter-value="${value}"]`);
      if (label) {
        label.setAttribute('data-category', category.name);
      }
    });
  });

  var conversionCategory;
  if (wrapper?.dataset?.sizeCategory === "shoe") {
    conversionCategory = sizesConversionConfig.shoes_conversions;
    if (wrapper?.dataset?.genderCategory === "woman") {
      conversionCategory = sizesConversionConfig.woman_shoes_conversions;
    } else if (wrapper?.dataset?.genderCategory === "man") {
      conversionCategory = sizesConversionConfig.man_shoes_conversions;
    }
  } else if (wrapper?.dataset?.sizeCategory === "clothing") {
    conversionCategory = sizesConversionConfig.clothing_conversions;
    if (wrapper?.dataset?.genderCategory === "woman") {
      conversionCategory = sizesConversionConfig.woman_clothing_conversions;
    } else if (wrapper?.dataset?.genderCategory === "man") {
      conversionCategory = sizesConversionConfig.man_clothing_conversions;
    }
  }
  if (!conversionCategory || conversionCategory.length <= 0) return;

  wrapper.querySelectorAll("label[data-category]").forEach((label) => {
    const checkbox = label.parentNode.querySelector('input[type="checkbox"]');
    const value = label.dataset.filterValue;
    const category = label.dataset.category;
    const conversions = conversionCategory.filter((conversions) => {
      const found = conversions.values.find(
        (valueObject) =>
          valueObject.value === value && valueObject.category === category
      );
      if (found) {
        if (!checkbox.disabled) {
          conversions.values.forEach((conversionValue) => {
            const checkbox = wrapper.querySelector(
              `input[type="checkbox"][value="${conversionValue.value}"]`
            );
            if (checkbox) {
              checkbox.disabled = false;
            }
          });
        }

        return true;
      } else {
        return false;
      }
    });
    if (conversions.length <= 0) return;

    conversions.forEach((conversion) => {
      conversion.values.forEach((conversionValue) => {
        const label = wrapper.querySelector(
          `label[data-category="${conversionValue.category}"][data-filter-value="${conversionValue.value}"]`
        );
        if (!label) {
          const fakeCheckbox = document.createElement("input");
          fakeCheckbox.setAttribute("type", "checkbox");
          fakeCheckbox.setAttribute(
            "id",
            `FakeCheckbox--${conversionValue.category}-${conversionValue.value}`
          );
          fakeCheckbox.setAttribute("value", conversionValue.value);
          fakeCheckbox.checked = checkbox.checked;
          fakeCheckbox.disabled = checkbox.disabled;

          const fakeLabel = document.createElement("label");
          fakeLabel.setAttribute(
            "for",
            `FakeCheckbox--${conversionValue.category}-${conversionValue.value}`
          );
          fakeLabel.setAttribute("data-filter-value", conversionValue.value);
          fakeLabel.setAttribute("data-category", conversionValue.category);
          fakeLabel.innerText = conversionValue.value;

          const fakeValueElement = document.createElement("div");
          fakeValueElement.classList.add(
            "facets__element",
            "facets__element--fake"
          );
          fakeValueElement.appendChild(fakeCheckbox);
          fakeValueElement.appendChild(fakeLabel);
          fakeValueElement.setAttribute('data-sort-value', conversionValue.value );

          wrapper.appendChild(fakeValueElement);
        }
      });
    });
  });

  const activeValuesWrapper = wrapper.closest('.js-filter').querySelector('.facets__values-counter');
  const isSizeInput = wrapper.closest('.facets__section--size');
  if (activeValuesWrapper) {
    const activeValuesCount = wrapper.querySelectorAll('input:checked').length;
    activeValuesWrapper.innerText = `(${activeValuesCount} ${activeValuesCount == 1 ? theme?.strings['selected_label_single'] : theme?.strings['selected_label_multiple']})`;
    if (activeValuesCount <= 0) {
      activeValuesWrapper.classList.add('hidden');
    } else {
      activeValuesWrapper.classList.remove('hidden');
    }
    }if(isSizeInput){
      activeValuesWrapper.classList.add('hidden');
    }

  categoriesSelect.querySelectorAll('.accordion-content [data-category-name]').forEach(category => {
    category.addEventListener('click', () => {
      categoryInput.value = category.dataset.categoryName;
      categoriesSelect.querySelector('summary [data-category-name]').innerText = category.innerText;
      window.dAgency.sizeSelectChange(category.dataset.categoryName, wrapper);
    });
  });

  categoryInput.value = wrapper.dataset.defaultCategory;
  categoriesSelect.querySelector('summary [data-category-name]').innerText = theme?.strings[wrapper.dataset.defaultCategory];
  window.dAgency.sizeSelectChange(wrapper.dataset.defaultCategory, wrapper);
  categoriesSelect.querySelector('summary').addEventListener('blur', function () {
    if (categoriesSelect.open) {
      this.click();
    }
  });
};

window.dAgency.sizesConversionSetup = wrapper => {
  var conversionCategory;
  if (wrapper?.dataset?.sizeCategory === 'shoe') {
    conversionCategory = sizesConversionConfig.shoes_conversions;
    if (wrapper?.dataset?.genderCategory === 'woman') {
      conversionCategory = sizesConversionConfig.woman_shoes_conversions;
    } else if (wrapper?.dataset?.genderCategory === 'man') {
      conversionCategory = sizesConversionConfig.man_shoes_conversions;
    }
  } else if (wrapper?.dataset?.sizeCategory === 'clothing') {
    conversionCategory = sizesConversionConfig.clothing_conversions;
    if (wrapper?.dataset?.genderCategory === 'woman') {
      conversionCategory = sizesConversionConfig.woman_clothing_conversions;
    } else if (wrapper?.dataset?.genderCategory === 'man') {
      conversionCategory = sizesConversionConfig.man_clothing_conversions;
    }
  }
  if (!conversionCategory || conversionCategory.length <= 0) return;
  wrapper.querySelectorAll('.facets__element label').forEach(label => {
    const checkbox = label.parentNode.querySelector('input[type="checkbox"]');
    const value = label.dataset.filterValue;
    const category = label.dataset.category;
    const conversions = conversionCategory.filter(conversions => {
      const found = conversions.values.find(valueObject => valueObject.value === value && valueObject.category === category);
      if (found) {
        return true;
      } else {
        return false;
      }
    });
    if (conversions.length <= 0) return;

    label.addEventListener('click', () => {
      conversions.forEach(conversion => {
        conversion.values.forEach(valueObject => {
          if (valueObject.category == category) return;

          const convertedLabel = wrapper.querySelector(`label[data-category="${valueObject.category}"][data-filter-value="${valueObject.value}"]`);
          if (convertedLabel) {
            const convertedCheckbox = convertedLabel.parentNode.querySelector('input[type="checkbox"]');
            if (convertedCheckbox && convertedCheckbox.checked == checkbox.checked) {
              convertedCheckbox.checked = !checkbox.checked;
            }
          }
        });
      });
    });
  });
};

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce(e => {
      this.onSubmitHandler(e);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    document.querySelectorAll('.collection-main-filters__active-filter[data-for]').forEach(activeFilter => {
      activeFilter.addEventListener('click', () => {
        const label = document.querySelector(`#FacetFiltersForm #${activeFilter.dataset.for} + label`);
        if (label) {
          label.click();
        }
      });
    });
    document.querySelectorAll('.js-filter .facets__search').forEach(searchWrapper => {
      window.dAgency.addSearchEvents(searchWrapper);
    });
    document.querySelectorAll('.js-filter .facets__list--size').forEach(sizesWrapper => {
      window.dAgency.updateSizesFilter(sizesWrapper);
      window.dAgency.sizesConversionSetup(sizesWrapper);
    });
    window.dAgency.initializeSelectRemoveAll(this);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    document.getElementById('ProductGridContainer').classList.add('loading');
    const url = `${window.location.pathname}?${searchParams}`;
    const filterDataUrl = element => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl) ?
      FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.completeRenderPage();
      })
      .catch(e => {
        console.error(e);
        FacetFiltersForm.completeRenderPage();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.completeRenderPage();
  }

  static completeRenderPage() {
    const gridContainer = document.getElementById('ProductGridContainer');
    gridContainer.classList.remove('loading');

    if (window.dAgency.proxyLinkSetup) window.dAgency.proxyLinkSetup(gridContainer);

    window.endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'click',
      callback: function (requestURL) {
        window.dAgency.ajaxinateCallBack(requestURL);
      }
    });
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderFilters(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const activeFiltersContainer = document.querySelector('.collection-main-filters__active-filters-wrapper');
    if (activeFiltersContainer) {
      activeFiltersContainer.innerHTML = '';
    }

    facetDetailsElements.forEach((element) => {
      const filterWrapper = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      const searchInput = filterWrapper.querySelector('.facets__search input');
      const categoryInput = filterWrapper.querySelector('input[data-selected-category]');
      filterWrapper.innerHTML = element.innerHTML;
      if (searchInput) {
        filterWrapper.querySelector('.facets__search input').value = searchInput.value;
        window.dAgency.searchFilter(searchInput.value, filterWrapper);
        window.dAgency.addSearchEvents(searchInput.closest('.facets__search'));
      }
      if (categoryInput) {
        window.dAgency.updateSizesFilter(filterWrapper.querySelector('.facets__list--size'));
        filterWrapper.querySelector('input[data-selected-category]').value = categoryInput.value;
        filterWrapper.querySelector('.facets__size-select summary [data-category-name]').innerText = theme?.strings[categoryInput.value];
        window.dAgency.sizeSelectChange(categoryInput.value, filterWrapper);
        window.dAgency.sizesConversionSetup(filterWrapper.querySelector('.facets__list--size'));
      }
      if (activeFiltersContainer && !element.classList.contains('facets__section--availability')) {
        filterWrapper.querySelectorAll('.facets__element:not(.facets__element--fake) input:checked + label').forEach(activeFilter => {
          const isSizeInput = activeFilter.closest('.facets__section--size');
          if (!isSizeInput) {
            const newElement = document.createElement('span');
            newElement.classList.add('collection-main-filters__active-filter');
            newElement.innerHTML = `${activeFilter.innerHTML}`;
            newElement.addEventListener('click', () => {
              const label = document.querySelector(`#FacetFiltersForm [id="${activeFilter.getAttribute('for')}"] + label`);
              if (label) {
                label.click();
              }
            });
            activeFiltersContainer.appendChild(newElement);
          }
        });
      }
    });

    const activeLabel = document.querySelector('.collection-main-filters__values-counter');
    if (activeLabel) {
      const activeCounter = document.querySelectorAll('.js-filter:not(.hidden):not(.facets__section--size) input:checked').length;
      activeLabel.innerHTML = `(${activeCounter} ${activeCounter > 1 ? activeLabel.dataset.multipleLabel : activeLabel.dataset.singleLabel})`;
      if (activeCounter > 0) {
        activeLabel.classList.remove('hidden');
      } else {
        activeLabel.classList.add('hidden');
      }
    }

    window.dAgency.initAccordions('.facets__accordions details:not(.facets__section--sorting)');
    window.dAgency.initializeSelectRemoveAll(document.querySelector('facet-filters-form'));
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (event.target?.type === 'text') {
      const filterWrapper = event.target.closest('.js-filter');
      window.dAgency.searchFilter(event.target.value, filterWrapper);
    } else {
      const availbleCheckbox = this.querySelector('.facets__section--availability input[type="checkbox"][value="1"]');
      if (availbleCheckbox) {
        if (this.querySelectorAll('.facets__section:not(.facets__section--availability) input[type="checkbox"]:checked').length > 0) {
          availbleCheckbox.checked = true;
        } else {
          availbleCheckbox.checked = false;
        }
      }
      const formData = new FormData(event.target.closest('form'));
      const searchParams = new URLSearchParams(formData).toString();
      FacetFiltersForm.renderPage(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define('facet-remove', FacetRemove);
